import {
  Box,
  Button,
  Card,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getStatusLabel } from "src/Utils/Combined";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import DeleteConfirmation from "src/Utils/DeleteConfirmation";
import { useState } from "react";
import { Edit, Visibility } from "@mui/icons-material";
import { imgUrl, url } from "src/Helpers/utils/Constant";
import PdfAndImageView from "src/components/pdfAndImageView/PdfAndImageView";
import CommonPdfAndImageVeiw from "src/components/pdfAndImageView/CommonPdfAndImageVeiw";
import { HttpClient } from "src/Helpers/http/http";
import Toaster from "src/Toaster/Toaster";
import UpdateHeroImage from "./UpdateHeroImage";

interface IDeleteResponse {
  success: boolean;
  message: string;
  code?: number;
}

export default function HeroSectiontableRow({
  index,
  heroimage,
  setHeroImages,
  setRefreshTrigger,
  heroImages,
}: {
  index: number;
  heroimage: any;
  setHeroImages: any;
  setRefreshTrigger: any;
  heroImages: any;
}) {
  const [open, setOpen] = useState<boolean>(false);
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleDelete = (slug: string) => {
    (async function () {
      console.log(slug);
      try {
        setIsLoading(true);
        const uri = `${url}/api/v1/admin/website-slider/${slug}`;

        const data = await HttpClient.delete<IDeleteResponse>(uri);

        if (data.success) {
          console.log(data.success, "success");
          const filterData = heroImages.filter((item) => item.slug != slug);
          console.log({ filterData });
          setHeroImages(filterData);

          Toaster().fire({
            icon: "success",
            title: "Deleted successfully!",
          });

          setIsLoading(false);
          setOpen(false);
          setRefreshTrigger((prev: number) => prev + 1);
        }
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
        Toaster().fire({
          icon: "error",
          title: `${error.response?.data?.message}`,
        });
      }
    })();
  };

  return (
    <>
      <TableRow hover>
        <TableCell>
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {index + 1}
          </Typography>
        </TableCell>

        {/* <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "35rem",
          }}
        >
          <Typography variant="body1" color="text.primary" gutterBottom>
            {heroimage?.content
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </Typography>
        </TableCell> */}

        <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Box
            component="img"
            src={`${imgUrl}/${heroimage.url}`}
            alt="Hero Image"
            sx={{
              width: 60,
              height: 60,
              borderRadius: 1,
              boxShadow: 2,
              objectFit: "cover",
            }}
          />
        </TableCell>
        <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "15rem",
          }}
        >
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {heroimage?.alt_text || "N/A"}
          </Typography>
        </TableCell>
        <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "20rem",
          }}
        >
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {heroimage?.order}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {getStatusLabel(heroimage.status)}
          </Typography>
        </TableCell>
        <TableCell>
          <Tooltip title="Edit" arrow>
            <IconButton
              onClick={() => setEditOpen(true)}
              sx={{
                "&:hover": {
                  background: theme.colors.primary.lighter,
                },
                color: theme.palette.primary.main,
              }}
              color="inherit"
              size="small"
            >
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton
              onClick={() => setOpen(true)}
              sx={{
                "&:hover": { background: theme.colors.error.lighter },
                color: theme.palette.error.main,
              }}
              color="inherit"
              size="small"
            >
              <DeleteTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* Delele Confirmation modal  */}
          <DeleteConfirmation
            open={open}
            handleClose={() => setOpen(false)}
            text={`Want to delete this hero image?`}
            handleDeleteFun={() => handleDelete(heroimage?.id)}
            loading={isLoading}
          />

          {/* Edit Modal */}
          <Dialog
            fullScreen={fullScreen}
            open={editOpen}
            maxWidth='md'
            onClose={() => setEditOpen(false)}
            aria-labelledby='responsive-dialog-title'
          >
            <DialogContent>
              <Box sx={{ mb: 2 }}>
                <Typography sx={{ mb: 2 }}>
                  Update Hero Image
                </Typography>
                <Divider />
              </Box>
              <UpdateHeroImage
                handleClose={() => setEditOpen(false)}
                heroimage={heroimage}
                setRefreshTrigger={setRefreshTrigger}
              />
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => setEditOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </TableCell>
      </TableRow>
    </>
  );
}
